module.exports = __webpack_public_path__ + "static/media/favicon.07b4fa7c.ico";